import React from "react";
import { createRoot } from "react-dom/client";
import TrackedApp from "./TrackedApp.tsx";

async function loadBrandCss() {
  const hostname = window.location.hostname;
  const isLoda = hostname === "loda.dk" || hostname.endsWith(".loda.dk");
  if (isLoda) {
    await import("./styles/loda-default.css");
  } else {
    await import("./styles/lara-default.css");
  }
  await import("./styles/globals.css");
}

async function bootstrap() {
  await loadBrandCss();

  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <TrackedApp />
    </React.StrictMode>
  );
}

bootstrap();
